// src/features/feedback/feedbackPanelStore.ts
//
// フィードバックパネルの開閉だけを共有する小さなストア。
// ヘッダーのボタン（画面ごとに作り直される）とパネル本体（アプリ全体で常駐）を
// つなぐ。入力内容は常駐側のコンポーネントが持つので、ここには置かない。
import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((listener) => listener());
}

export function setFeedbackPanelOpen(next: boolean): void {
  if (open === next) return;
  open = next;
  emit();
}

export function toggleFeedbackPanel(): void {
  setFeedbackPanelOpen(!open);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useFeedbackPanelOpen(): boolean {
  return useSyncExternalStore(subscribe, () => open, () => false);
}
